 <template>
  <div style="height:100%">
    <!-- 表格 -->
    <div style="height:82%;background-color:#fff;border-radius:8px;padding: 20px">
      <el-button type="primary" size="small" style="margin-bottom:20px" @click="add">新增</el-button>
      <el-table :data="tableData" stripe height="80%" size="small" :header-cell-style="{'background-color':'#344158cc','color':'#fff','text-align':'center'}" :cell-style="{'text-align':'center'}">
        <el-table-column prop="zhTitle" label="中文标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="enTitle" label="英文标题" show-overflow-tooltip></el-table-column>
        <el-table-column prop="zhContent" label="中文内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="enContent" label="英文内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="80px">
          <template scope="scope">
            <el-row>
              <el-col :span="12">
                <el-tooltip effect="dark" content="编辑" placement="top-end">
                  <el-button type="primary" icon="el-icon-edit" circle size="mini" @click="edit(scope.row)"></el-button>
                </el-tooltip>
              </el-col>
              <el-col :span="12">
                <el-tooltip effect="dark" content="删除" placement="top-end">
                  <el-popconfirm title="确认删除吗？" @confirm="delSubMit(scope.row)">
                    <el-button content="删除" slot="reference" type="danger" icon="el-icon-delete" circle size="mini"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹出层 -->
    <el-dialog title="新增" :visible.sync="dialogFormAdd" width="800px" :close-on-click-modal="false" top="50px">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
        <el-form-item label="中文标题" prop="zhTitle">
          <el-input v-model="addParams.zhTitle"></el-input>
        </el-form-item>
        <el-form-item label="英文标题" prop="enTitle">
          <el-input v-model="addParams.enTitle"></el-input>
        </el-form-item>
        <el-form-item label="中文内容" prop="zhContent">
          <el-input v-model="addParams.zhContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <el-form-item label="英文内容" prop="enContent">
          <el-input v-model="addParams.enContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormAdd = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="addSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑弹出层 -->
    <el-dialog title="编辑" :visible.sync="dialogFormEdit" width="800px" :close-on-click-modal="false" top="50px">
      <el-form :model="addParams" :rules="rules" ref="addParams" label-width="160px" size="small" style="width:500px">
        <el-form-item label="中文标题" prop="zhTitle">
          <el-input v-model="addParams.zhTitle"></el-input>
        </el-form-item>
        <el-form-item label="英文标题" prop="enTitle">
          <el-input v-model="addParams.enTitle"></el-input>
        </el-form-item>
        <el-form-item label="中文内容" prop="zhContent">
          <el-input v-model="addParams.zhContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
        <el-form-item label="英文内容" prop="enContent">
          <el-input v-model="addParams.enContent" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top:50px">
        <el-button @click="dialogFormEdit = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="editSubMit('addParams')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path:'/y-scope-detail',
      total: 0,
      tableData: [],
      dialogFormAdd: false,
      dialogFormEdit: false,
      addParams: {
        id:"",
        zhTitle:"",
        enTitle:"",
        zhContent:"",
        enContent:"",
      },
      rules: {
        enTitle: [
          { required: true, message: '请输入英文标题', trigger: 'blur' }
        ],
        zhTitle: [
          { required: true, message: '请输中文标题', trigger: 'blur' }
        ],
        zhContent: [
          { required: true, message: '请输入中文内容', trigger: 'blur' }
        ],
        enContent: [
          { required: true, message: '请输英文内容', trigger: 'blur' }
        ],
      },
      tempImagePath:'',
    };
  },
  created() {
    this.list()
  },
  methods:{
    list() {
      this.axios({
        method: "get",
        url: this.path+"/list"
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.total = res.data.data.total;
      });
    },
    add(){//新增弹出层
      this.tempImagePath=""
      this.dialogFormAdd = true;
      this.addParams = {};
    },
    edit(row){//编辑弹出层
      this.addParams = row;
      this.dialogFormEdit = true;
    },
    addSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          this.$set( this.addParams,"zhTitle", this.addParams.zhTitle.replace(/\n/g, '<br/>'))
          this.$set( this.addParams,"enTitle", this.addParams.enTitle.replace(/\n/g, '<br/>'))
          this.$set( this.addParams,"zhContent", this.addParams.zhContent.replace(/\n/g, '<br/>'))
          this.$set( this.addParams,"enContent", this.addParams.enContent.replace(/\n/g, '<br/>'))
          this.axios({
            method: "post",
            url: this.path+"/add",
            data: this.addParams,
          })
          .then((res) => {
            if (res.data.code === 200) {
              this.dialogFormAdd = false;
              this.$message({message: "添加成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    editSubMit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false
        }else {
          this.addParams.zhTitle =this.addParams.zhTitle.replace(/\n/g, '<br>')
          this.addParams.enTitle =this.addParams.enTitle.replace(/\n/g, '<br>')
          this.addParams.zhContent =this.addParams.zhContent.replace(/\n/g, '<br>')
          this.addParams.enContent =this.addParams.enContent.replace(/\n/g, '<br>')
          this.axios({
            method: "post",
            url: this.path+"/update",
            data: this.addParams,
          }).then((res) => {
            if (res.data.code === 200) {
              this.dialogFormEdit = false;
              this.$message({message: "修改成功",type: "success"});
              this.list();
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      })
    },
    delSubMit(row){//删除
      this.axios({
        method: "delete",
        url: this.path+"/delete",
        params: {
          id: row.id,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({message: "删除成功",type: "success"});
          this.list();
        }else{
          this.$message({type:"error",message: res.data.message});
        }
      });
    },
    onSearch(){
      this.list();
    },
  }
};
</script>

<style>

</style>